<!-- スライドメニュー -->
<template>
  <transition name="slideMenu">
    <div v-if="showMenu" class="crly-o-common-slide-menu">
      <div class="crly-o-common-slide-menu__close-area" @click="clickClose">
        <div></div>
      </div>
      <div class="drawer-menu" @touchmove.stop="">
        <ul class="crly-o-common-slide-menu__main">
          <template v-for="menuItem in menuItemList">
            <CrlyMCommonSlideMenu
              @menuClose="clickClose"
              :menuItem="menuItem"
              :key="menuItem.type"
              :unreadCount="getUnreadCount"
              v-if="
                menuItem.isLogin ? isLoggedIn : menuItem.type != 'news'
              "
            />
            <template v-for="children in menuItem.children">
              <CrlyMCommonSlideMenu
                @menuClose="clickClose"
                :menuItem="children"
                :key="children.type"
                :isChild="true"
                v-if="
                  children.isLogin ? isLoggedIn : menuItem.type != 'news'
                "
              />
            </template>
            <CrlyMoleculesCommonAccordion
              :initStatus="initStatus"
              v-if="menuItem.type == 'news'"
              :key="menuItem.type"
            >
              <template v-slot:toggle>
                <CrlyAtomsCommonBtnSideMenuToggle
                  :title="menuItem.name"
                  :type="'toggle'"
                  :unreadCount="unreadCount"
                  @close="clickClose"
                />
              </template>
              <template v-slot:contents>
                <CrlyOrganismsNewsList sideMenu @close="clickClose" />
              </template>
            </CrlyMoleculesCommonAccordion>
          </template>
        </ul>
      </div>
    </div>
  </transition>
</template>

<script>
import CrlyMCommonSlideMenu from "@crly/components/molecules/common/SlideMenuItem.vue";
import CrlyAtomsCommonBtnSideMenuToggle from "@crly/components/atoms/common/btn/SideMenuToggle.vue";
import CrlyMoleculesCommonAccordion from "@crly/components/molecules/common/Accordion.vue";
import CrlyOrganismsNewsList from "@crly/components/organisms/news/List.vue";

export default {
  name: "CrlyOrganismsCommonSlideMenu",
  components: {
    CrlyMCommonSlideMenu,
    CrlyAtomsCommonBtnSideMenuToggle,
    CrlyMoleculesCommonAccordion,
    CrlyOrganismsNewsList
  },
  props: {
    /**
     * スライドメニューの表示状態
     */
    showMenu: {
      type: Boolean,
      default: false
    },
    initStatus: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    // お知らせ取得
    this.getNews();
  },
  data() {
    return {
      unreadCount: 0,
      infoList: [],
      infoIdList: [],
      menuItemList: [
        {
          name: this.$t("common.slideMenu.guide"),
          type: "guide",
          linkName: "CrlyGuide",
          isLogin: false
        },
        {
          name: this.$t("common.slideMenu.help"),
          type: "help",
          linkName: "CrlyFAQ",
          isLogin: false
        },
        {
          name: this.$t("common.slideMenu.news"),
          type: "news",
          linkName: "CrlyNews",
          isLogin: false
        },
        {
          name: this.$t("common.slideMenu.memberStatus"),
          type: "memberStatus",
          linkName: "CrlyMemberStatus",
          isLogin: false
        },
        {
          name: this.$t("common.slideMenu.myPage"),
          type: "myPage",
          linkName: "MyPage",
          isLogin: true,
          children: [
            { // ご利用履歴（申し込み履歴）
              name: this.$t("common.slideMenu.history"),
              type: "history",
              linkName: "MypageOrders",
              isLogin: true
            },
            { // ベネポの確認
              name: this.$t("common.slideMenu.benepo"),
              type: "benepo",
              linkName: "MypageBenepo",
              isLogin: true
            },
            { // 個人設定
              name: this.$t("common.slideMenu.setting"),
              type: "personalSettings",
              linkName: "MypageSetting",
              isLogin: true
            }
          ]
        },
        {
          name: this.$t("common.slideMenu.opinion"),
          type: "opinionBox",
          linkName: "CrlyOpinionBox",
          isLogin: true,
          before: () => {
            // 保存されているデータを初期化する
            this.$store.commit("opinionState/init", this.message);
          }
        },
        {
          name: this.$t("common.slideMenu.logout"),
          type: "logout",
          isLogin: true
        },
        {
          name: this.$t("common.slideMenu.about"),
          type: "promotion",
          linkName: "CrlyPromotion",
          isLogin: false
        }
      ]
    };
  },
  computed: {
    /**
     * お知らせ未読数を取得
     */
    getUnreadCount() {
      return this.calcUnreadCount();
    }
  },
  methods: {
    clickClose() {
      this.$emit("clickMenusClose", false);
    },
    getNews() {
      this.infoList = [];
      this.$repositories("cms")
        .getNews()
        .then((res) => {
          this.dataMaker(res);
          this.controlPagination = res.data.links;
        });
    },
    dataMaker(obj) {
      const lists = obj.data.data;
      const newsTypeNames = obj.data.included;
      if (lists != null) {
        lists.forEach((item) => {
          const newsTypeName = newsTypeNames.find(
            (el) => el.id === item.relationships.news_type.data.id
          );
          this.infoList.push({
            pub_date: item.attributes.pub_date,
            news_type_name: newsTypeName.attributes.name,
            display_title: item.attributes.display_title,
            id: item.id
          });
          this.infoIdList.push(item.id);
        });
      }
    },
    /**
     * お知らせ未読数を算出
     */
    calcUnreadCount() {
      let cnt = Number(this.infoIdList.length) - this.getReadCount();
      this.unreadCount = cnt;
      return cnt;
    },
    /**
     *  既読一覧をCookie、またはローカルストレージから取得
     */
    getReadCount() {
      let dateStorage = this.$store.getters[
        "clickNewsLStorage/getLastUpdateDate"
      ];
      let dateCookie = this.$store.getters["clickNewsCookie/getLastUpdateDate"];
      let newsList = this.$store.getters["clickNewsCookie/getNews"];
      if (dateCookie) {
        if (!dateStorage || dateCookie > dateStorage) {
          // クッキーの方が新しいorローカルストレージに情報が無い
          // ⇒クッキーの内容でローカルストレージを上書き
          newsList = this.$store.getters["clickNewsCookie/getNews"];
          this.$store.commit("clickNewsLStorage/setNews", newsList);
          this.$store.commit("clickNewsLStorage/setLastUpdateDate", dateCookie);
        } else {
          // クッキーの方が古い
          // ⇒クッキーをローカルストレージの内容で上書き（ローカルストレージの日時）
          newsList = this.$store.getters["clickNewsLStorage/getNews"];
          this.$store.commit("clickNewsCookie/setNews", newsList);
          this.$store.commit("clickNewsCookie/setLastUpdateDate", dateStorage);
        }
      } else {
        // クッキーに情報が無い場合
        if (dateStorage) {
          // ローカルストレージに情報がある場合
          // ⇒クッキーにローカルストレージの内容を書き込み（ローカルストレージの日時）
          newsList = this.$store.getters["clickNewsLStorage/getNews"];
          this.$store.commit("clickNewsCookie/setNews", newsList);
          this.$store.commit("clickNewsCookie/setLastUpdateDate", dateStorage);
        }
      }
      return newsList.length;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@crly/assets/css/organisms/common/slideMenu.scss";
</style>
